export default __webpack_public_path__ + "static/ivanovo-f03d129f6d8b1912a641fc7f08045b12.webp";